import { element } from '../../global/template-literals.js';
import { UIElement } from '../ui-element.js';
import styles from './ui-header.css';

/**
 * @memberof SharedComponents
 * @augments {UIElement}
 * @alias UIHeader
 * @element ui-header
 * @classdesc Represents a class for <code>ui-header</code> element.
 * @property {UIHeaderType} [type="default"] {@attr type} Type of header.
 * @property {UIHeaderToolbar} sidebar {@readonly} Shortcut to UIHeaderToolbar child element.
 * @property {UIHeaderContent} content {@readonly} Shortcut to UIHeaderContent child element.
 * @example
 * <ui-header>
 * </ui-header>
 */

class UIHeader extends UIElement {
    /**
     * @type {Props}
     * @readonly
     */
    static get props() {
        return {
            attributes: {
                type: {
                    type: String,
                    default: UIHeader.Type.Default,
                },
            },
            children: {
                toolbar: 'ui-header-toolbar',
                content: 'ui-header-content',
            },
        };
    }

    /**
     * @private
     * @returns {UIHeaderTypes}
     */
    static get Type() {
        return {
            Default: 'default',
            Box: 'box',
        };
    }

    /**
     * List of allowed header children
     */
    static get allowedHeaderTags() {
        return ['ui-header-toolbar', 'ui-header-content', 'ui-header-row'];
    }

    /**
     * @inheritDoc
     */
    render() {
        const headerNodes = this.detachChildNodes().filter((node) => {
            return (
                node.tagName &&
                UIHeader.allowedHeaderTags.includes(node.tagName.toLowerCase())
            );
        });

        this.append(
            element`
            <header role="banner">
              ${headerNodes}
            </header>
            `
        );
    }
}

UIHeader.defineElement('ui-header', styles);
export { UIHeader };
